export default "__VITE_ASSET__BdEAQa7x__"